import React, {useContext, useState} from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "../../components/";
import { GetRenewalPoliciesListColumns } from "./RenewalPoliciesListColumns";
import useToggle from "../../../hooks/Toggle";
import {_RenewalActionDialog} from "./ActionDialog";
import ChiamaWeb, { CChiamaWebParametri } from "../../../ChiamaWeb";
import {AlertDialogContext} from "../../providers/AlertDialogProvider";
import moment from "moment/moment";


const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative",
        "& .expired span, & .expiring span": {
            display: "inline-block",
            padding: "4px",
            borderRadius: "10px"
        },
        "& .expired span": {
            background: palette.error.main
        },
        "& .expiring span": {
            background: palette.warning.light
        },
        "& .polizza span": {
            background: palette.success.light,
            display: "inline-block",
            padding: "1px 5px 1px 5px",
            borderRadius: "5px"
        },
        "& .tacito span": {
            background: palette.success.light,
            display: "inline-block",
            padding: "1px 5px 1px 5px",
            borderRadius: "5px"
        }
    }
}));

interface IPoliciesListTableProps {
    Data: Dati.CRisAPIPaginePolizzaGenerale | undefined;
    IsLoading: boolean;
    Options: MUIDataTableOptions;
    AutoRefresh: boolean;
    AutoClick: boolean;
    OnRefresh: () => void;
}

export const _RenewalPoliciesListTable: React.FC<IPoliciesListTableProps> = 
    React.memo(({ Data, IsLoading, Options, AutoRefresh, AutoClick, OnRefresh}) => {
    const classes = useStyles();
    const {ShowDialog} = useContext(AlertDialogContext); 
    
    const { open: openRenew, toggle: toggleRenew } = useToggle();
    const { open: openCreateNew, toggle: toggleCreateNew } = useToggle();
    const { open: openTerminate, toggle: toggleTerminate } = useToggle();

    const [policy, setPolicy] = useState(new Dati.CDatiPolizzaGenerale());

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };
        
    const OnClickRenew = (policy: Dati.CDatiPolizzaGenerale): void => {
        setPolicy(policy);
        toggleRenew();
    };

    const OnRenew = (): void => {
        const Param: CChiamaWebParametri = {
            Metodo: "PUT",
            URL: `/api/Polizza/RinnovaPolizzaRCP?idPolicy=${policy.ID_Polizza}`,
            OnRis: () => {
                if (AutoRefresh)
                {
                    OnRefresh();
                }
                toggleRenew();
                IsLoading = false;
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };
    
    const OnClickCreateNew = (policy: Dati.CDatiPolizzaGenerale): void => {
        setPolicy(policy);
        toggleCreateNew();
    };
    
    const OnCreateNew = (): void => {
        IsLoading = true;
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/Renewals/CreateQuotationFromPolicy?idPolicy=${policy.ID_Polizza}&idGroupType=${policy.ID_TipoRamo}&endDate=${moment(policy.DataFine).utc().format()}`,
            OnRis: () => {
                if (AutoRefresh)
                {
                    OnRefresh();
                }
                toggleCreateNew();
                IsLoading = false;
                },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };
    
    const OnClickTerminate = (policy: Dati.CDatiPolizzaGenerale): void => {
        setPolicy(policy);
        toggleTerminate();
    };  
    
    const OnTerminate = (): void => {
        const Param: CChiamaWebParametri = {
            Metodo: "PUT",
            URL: `/api/Polizza/ChangeStateToTermination?idPolicy=${policy.ID_Polizza}`,
            OnRis: () => {
                if (AutoRefresh)
                {
                    OnRefresh();
                }
                toggleTerminate();
                IsLoading = false;
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable 
                title="" 
                data={Data?.Dati || []} 
                columns={GetRenewalPoliciesListColumns(Data?.Dati, OnClickRenew, OnClickCreateNew, OnClickTerminate)} 
                options={Options} 
            />
            <_RenewalActionDialog 
                Open={openRenew}
                Title={"Confirm"}
                Message={`Rinnovare la polizza ${policy.Polizza}?`}
                OnCancel={toggleRenew}
                OnConfirm={OnRenew}
                OnClose={toggleRenew}
            />
            <_RenewalActionDialog
                Open={openCreateNew}
                Title={"Confirm"}
                Message={`Creare il nuovo preventivo per la polizza ${policy.Polizza}?`}
                OnCancel={toggleCreateNew}
                OnConfirm={OnCreateNew}
                OnClose={toggleCreateNew}
            />
            <_RenewalActionDialog
                Open={openTerminate}
                Title={"Confirm"}
                Message={`Disdire la polizza ${policy.Polizza}?`}
                OnCancel={toggleTerminate}
                OnConfirm={OnTerminate}
                OnClose={toggleTerminate}
            />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/RenewalPoliciesList/RenewalPoliciesListTable.tsx